export const FORM_NAME = Object.freeze({
  VERSION_CREATE: 'versionCreate',
  BLOCK_VERSION_CREATE: 'blockVersionCreate',
  VERSION_RENAME: 'versionRename',
  BLOCK_VERSION_RENAME: 'blockVersionRename',
  OPTION_CREATE: 'optionCreate',
  STATUS_CHANGE_CONFIRMATION: 'statusChangeConfirmation'
})
